import { createFileRoute } from '@tanstack/react-router';
import { ReactElement } from 'react';

import { TimesheetPage } from '@/features/timesheet/timesheet.page';

export const Route = createFileRoute('/__authenticated/timesheet/')({
	staticData: { titleKey: 'navigation.timeSheet' },
	component: RouteComponent,
});

function RouteComponent(): ReactElement {
	return <TimesheetPage />;
}
